import React from "react";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";
import logo from "../../Assets/images/B&W.png";

const Footer = () => {
  return (
    <Fade up>
      <div>
        <div className="" style={{ overFlow: "hidden" }}>
          <svg
            preserveAspectRatio="none"
            viewBox="0 0 1200 120"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              fill: "#5E3091",
              width: "100%",
              height: 75,
              transform: "rotate(180deg)",
            }}
          >
            <path
              d="M0 0v46.29c47.79 22.2 103.59 32.17 158 28 70.36-5.37 136.33-33.31 206.8-37.5 73.84-4.36 147.54 16.88 218.2 35.26 69.27 18 138.3 24.88 209.4 13.08 36.15-6 69.85-17.84 104.45-29.34C989.49 25 1113-14.29 1200 52.47V0z"
              opacity=".25"
            />
            <path
              d="M0 0v15.81c13 21.11 27.64 41.05 47.69 56.24C99.41 111.27 165 111 224.58 91.58c31.15-10.15 60.09-26.07 89.67-39.8 40.92-19 84.73-46 130.83-49.67 36.26-2.85 70.9 9.42 98.6 31.56 31.77 25.39 62.32 62 103.63 73 40.44 10.79 81.35-6.69 119.13-24.28s75.16-39 116.92-43.05c59.73-5.85 113.28 22.88 168.9 38.84 30.2 8.66 59 6.17 87.09-7.5 22.43-10.89 48-26.93 60.65-49.24V0z"
              opacity=".5"
            />
            <path d="M0 0v5.63C149.93 59 314.09 71.32 475.83 42.57c43-7.64 84.23-20.12 127.61-26.46 59-8.63 112.48 12.24 165.56 35.4C827.93 77.22 886 95.24 951.2 90c86.53-7 172.46-45.71 248.8-84.81V0z" />
          </svg>
        </div>
        <div style={{ background: "#5e3091" }}>
          <footer className="footer p-10 text-slate-200">
            <div>
              <span className="font-bold text-xl">Services</span>
              <Link to="" className="link link-hover">
                Graphics Design
              </Link>
              <Link to="" className="link link-hover">
                Web Design & Development
              </Link>
              <Link to="" className="link link-hover">
                Video & Animation
              </Link>
              <Link to="" className="link link-hover">
                Digital Marketing
              </Link>
            </div>
            <div>
              <span className="font-bold text-xl">Company</span>
              <Link to="" className="link link-hover">
                About us
              </Link>
              <Link to="/contact" className="link link-hover">
                Contact
              </Link>
              <Link to="" className="link link-hover">
                Jobs
              </Link>
              <Link to="" className="link link-hover">
                Press kit
              </Link>
            </div>
            <div>
              <span className="font-bold text-xl">Contact</span>
              {/* <Link to="" className="link link-hover">
            Terms of use
          </Link>
          <Link to="" className="link link-hover">
            Privacy policy
          </Link>
          <Link to="" className="link link-hover">
            Cookie policy
          </Link> */}
              <p>
                <span className="font-bold">Mobile:</span> +8801700-000000
              </p>
              <p>
                <span className="font-bold">Email:</span> mehraf.ais@gmail.com
              </p>
              <p>
                <span className="font-bold">Address:</span> Bogura-5800
              </p>
            </div>
          </footer>
          <footer className="footer px-10 py-4 text-slate-200">
            <div className="items-center grid-flow-col">
              <img className="h-10" src={logo} alt="" />
              <p>
                <span className="font-bold">MEHRAF ALL IT SOLUTIONS.</span>{" "}
                <br />
                Established in 2022
                <br />
                &copy; All Rights Reserved by{" "}
                <span className="font-bold">MEHRAF</span>
              </p>
            </div>
            <div className="md:place-self-center md:justify-self-end">
              <div className="grid grid-flow-col gap-4">
                <a>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="fill-current"
                  >
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path>
                  </svg>
                </a>
                <a>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="fill-current"
                  >
                    <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"></path>
                  </svg>
                </a>
                <a>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="fill-current"
                  >
                    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </Fade>
  );
};

export default Footer;
